module.exports = __webpack_public_path__ + "assets/custom-asset-icon-active.e242512d.svg";